/**
 * Excess-km billing at return (OPS-2). Pure: the server fixes the per-category
 * price onto the rental at hand-over and calls this with the readings at return.
 * Unconfigured (either value null) means unlimited: no allowance, no charge.
 * All integer math — km are whole, the charge is integer cents.
 */
export interface ExcessKmInput {
  /** Odometer at hand-over and return; kmIn >= kmOut is enforced upstream. */
  kmOut: number
  kmIn: number
  /** Fixed onto the rental at hand-over; null = unlimited for this rental. */
  includedKmPerDay: number | null
  /** Price per excess km in cents, fixed at hand-over; null = unlimited. */
  excessKmCents: number | null
  /** The reservation's billed days (reservations.billable_days). */
  billedDays: number
}

export interface ExcessKm {
  driven: number
  included: number
  excess: number
  chargeCents: number
}

export function excessKm(input: ExcessKmInput): ExcessKm {
  const driven = Math.max(0, input.kmIn - input.kmOut)
  if (input.includedKmPerDay === null || input.excessKmCents === null) {
    return { driven, included: 0, excess: 0, chargeCents: 0 }
  }
  const included = input.includedKmPerDay * input.billedDays
  const excess = Math.max(0, driven - included)
  return { driven, included, excess, chargeCents: excess * input.excessKmCents }
}
